import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import type { WindowedStudioSubmitData } from '../../types';
import { annotationLabelsAtom } from '../atoms/annotation-atoms';
import { relationshipStoreAtom } from '../atoms/relationship-atoms';
import { studioConfigAtom, studioStoreAtom } from '../atoms/studio-store';
export function useWindowedSubmitData() {
  const getStudioConfig = useAtomCallback(useCallback(get => get(studioConfigAtom), []));
  const getStudioStore = useAtomCallback(useCallback(get => get(studioStoreAtom), []));
  const getAnnotationLabels = useAtomCallback(useCallback(get => get(annotationLabelsAtom), []));
  const getRelationshipStore = useAtomCallback(useCallback(get => get(relationshipStoreAtom), []));
  const getWindowedSubmitData = useCallback((): WindowedStudioSubmitData | null => {
    const config = getStudioConfig();
    const studioStore = getStudioStore();
    const annotationMetadata = studioStore?.getAnnotationMetadata() ?? new Map();
    const annotationLabels = getAnnotationLabels();
    if (config?.mode !== 'windowed') {
      return null;
    }
    return {
      annotationMetadata,
      annotationLabels,
      relationships: getRelationshipStore()
    };
  }, [getStudioConfig, getStudioStore, getAnnotationLabels, getRelationshipStore]);
  return {
    getWindowedSubmitData
  };
}